import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import { envAwarePost } from "../util/util";


export const editTrainerPageImages = createAsyncThunk(
    "editTrainerPageImages",
    async (payload) => envAwarePost("api/users/api.php", {
        action: "editTrainerPageImages",
        ...payload
    })
);

export const getTrainerPagesImages = createAsyncThunk(
    "getTrainerPagesImages",
    async (payload) => envAwarePost("api/users/api.php", {
        action: "getTrainerPageImages"
    })
);

export const getTrainerPageServices = createAsyncThunk(
    "getTrainerPageServices",
    async () => envAwarePost("api/users/api.php", {
        action: "getTrainerPageServices"
    })
);

export const removeTrainerPageService = createAsyncThunk(
    "removeTrainerPageService",
    async (payload) => envAwarePost("api/users/api.php", {
        action: "removeTrainerPageService",
        ...payload
    })
);

export const editTrainerPageService = createAsyncThunk(
    "editTrainerPageService",
    async (payload) => envAwarePost("api/users/api.php", {
        action: "editTrainerPageService",
        ...payload
    })
);

export const createTrainerPageService = createAsyncThunk(
    "createTrainerPageService",
    async (payload) => envAwarePost("api/users/api.php", {
        action: "createTrainerPageService",
        ...payload
    })
);

export const getTrainerPageHeaders = createAsyncThunk(
    "getTrainerPageHeaders",
    async (payload) => envAwarePost("api/users/api.php", {
        action: "getTrainerPageHeaders",
    })
);

export const editTrainerPageHeader = createAsyncThunk(
    "editTrainerPageHeader",
    async (payload) => envAwarePost("api/users/api.php", {
        action: "editTrainerPageHeader",
        ...payload
    })
);

const trainerPageServicesAdapter = createEntityAdapter({
    selectId: ent => ent?.id,
    status: 'idle',
})

const trainerPageSlice = createSlice({
    name: "trainerPageSlice",
    initialState: {
        trainerPageImages: [],
        services: trainerPageServicesAdapter.getInitialState(),
        servicesStatus: 'init',
        trainerPageHeaders: {
            certifications: null,
            specialty: null
        },
        sectionImages:{
            certifications:null,
            specialty:null
        }
    },
    reducers: {},
    extraReducers: {
        [getTrainerPagesImages.fulfilled]: (state, action) => {
            // console.log(action);
            const images = action.payload.data.trainerPageImages
            state.trainerPageImages = images
            images.forEach(({category_id_name,img})=>{
                if(category_id_name==='certifications_img'){
                    state.sectionImages.certifications = img
                }else{
                    state.sectionImages.specialty = img
                }
            })
        },
        [editTrainerPageImages.pending]: (state,action)=>{
            const img = action.meta.arg.img
            const category_id_name = action.meta.arg.category
            if ( category_id_name === 'certifications_img' ) {
                state.sectionImages.certifications = img
            } else {
                state.sectionImages.specialty = img
            }
        },
        [getTrainerPageServices.fulfilled]: (state, action) => {
            const { data } = action.payload;
            trainerPageServicesAdapter.setAll(state.services, data.services)
            state.servicesStatus = 'idle';
        },
        //remove resource pending
        [removeTrainerPageService.pending]: (state, action) => {
            let id = action.meta.arg.id;
            trainerPageServicesAdapter.removeOne(state.services, id)
        },
        //edit resource
        [editTrainerPageService.pending]: (state, action) => {
            const { id, ...changes } = action.meta.arg
            trainerPageServicesAdapter.updateOne(state.services, { id, changes })
        },
        //create resource
        [createTrainerPageService.fulfilled]: (state, action) => {
            const { success, data } = action.payload
            if (success === '1') trainerPageServicesAdapter.addOne(state.services, data.services)
        },
        //create resource
        [getTrainerPageHeaders.fulfilled]: (state, action) => {
            const { success, data } = action.payload
            if (success === '1') {
                state.trainerPageHeaders.certifications = data.trainer_page_headers.certifications;
                state.trainerPageHeaders.specialty =  data.trainer_page_headers.specialty;

            }
        },
    },
});

// Export the customized selectors for this adapter using `getSelectors`
export const {
    selectAll: selectAllServices,
    selectById: selectServiceById,
    selectIds: selectServicesById
} = trainerPageServicesAdapter.getSelectors(state => state.trainerPage.services)


export default trainerPageSlice.reducer;
